// Lives outside init.ts so pure-utility importers (lib/util.ts and the jest
// suites behind it) don't pull in init.ts's `import.meta` usage, which
// ts-jest's CommonJS output can't compile. initApp()/disposeApp() wire the
// mode and handler via configureRestart().

let embedded = false;
let restartHandler: ((route?: string) => void) | undefined;

export function configureRestart(options: { embedded: boolean; onRestartRequest?: (route?: string) => void }) {
    embedded = options.embedded;
    restartHandler = options.onRestartRequest;
}

/**
 * Embed-aware replacement for `window.location.reload()`: standalone mode
 * reloads the page, embedded mode asks the wrapper for a dispose/re-mount
 * cycle instead of reloading the partner host page (PTC-3919).
 *
 * `route` (embedded only) re-mounts at that route instead of the current one —
 * the counterpart of standalone's `location.assign(basePath + route)`.
 * Standalone callers navigate themselves before/instead of reloading.
 */
export function restart(route?: string) {
    if (embedded) {
        if (restartHandler) {
            restartHandler(route);
        } else {
            console.warn("App restart requested, but no onRestartRequest handler is configured");
        }
        return;
    }
    window.location.reload();
}
